(() => {
// ══════════════════════════════════════════════════════════
//  株価予測 × モンテカルロ ハイブリッド
//  段階1: LSTM予測（TF.js, CPU）→ μ・σ
//  段階2: モンテカルロ（gwaw-compute.js, GPU）→ 確率の帯
//  ※ import/export なし・グローバル関数（parcel build 対応）
// ══════════════════════════════════════════════════════════
// ── 状態管理 ──────────────────────────────────────────
let $9024cd3e80ddf5bc$var$closeData = []; // 終値の数値配列
let $9024cd3e80ddf5bc$var$dataSource = 'syn'; // 'yf' | 'csv' | 'syn'
let $9024cd3e80ddf5bc$var$lstmOutput = null; // { futPred, lastActual, mu, sigma, rmse }
let $9024cd3e80ddf5bc$var$mcOutput = null; // simulatePaths の結果
let $9024cd3e80ddf5bc$var$chartMain = null, $9024cd3e80ddf5bc$var$chartFan = null;
const $9024cd3e80ddf5bc$var$gc = new GwawCompute();
// ── バックエンド初期化（LSTM=CPU固定、MC=自動） ──────────
(async ()=>{
    try {
        await tf.setBackend('cpu');
        await tf.ready();
        document.getElementById('lstmBackend').textContent = 'LSTM: CPU';
    } catch (e) {
        document.getElementById('lstmBackend').textContent = 'LSTM: error';
    }
    await $9024cd3e80ddf5bc$var$gc.detect();
    document.getElementById('mcBackend').textContent = 'MC: ' + ($9024cd3e80ddf5bc$var$gc.capabilities.webgpu ? 'WebGPU' : 'CPU');
})();
// ── ログ ─────────────────────────────────────────────
function $9024cd3e80ddf5bc$var$log(msg, cls = '') {
    const box = document.getElementById('logBox');
    const s = document.createElement('span');
    if (cls) s.className = cls;
    s.innerHTML = msg + '<br>';
    box.appendChild(s);
    box.scrollTop = box.scrollHeight;
}
function $9024cd3e80ddf5bc$var$clearLog() {
    document.getElementById('logBox').innerHTML = '';
}
// ── データソース切替 ──────────────────────────────────
function $9024cd3e80ddf5bc$var$switchDs(t) {
    $9024cd3e80ddf5bc$var$dataSource = t;
    [
        'yf',
        'csv',
        'syn'
    ].forEach((k)=>{
        const tab = document.getElementById('dsTab' + k.charAt(0).toUpperCase() + k.slice(1));
        if (tab) tab.classList.toggle('active', k === t);
        const panel = document.getElementById('dsPanel' + k.charAt(0).toUpperCase() + k.slice(1));
        if (panel) panel.style.display = k === t ? 'block' : 'none';
    });
}
// ── Yahoo Finance プロキシ ────────────────────────────
function $9024cd3e80ddf5bc$var$buildProxies(symbol, range) {
    // 自サーバープロキシ（最優先・CORS問題なし）
    const selfProxy = 'https://www.iseeit.jp/tools/yf-proxy.php' + `?symbol=${encodeURIComponent(symbol)}&range=${encodeURIComponent(range)}`;
    // 外部プロキシ（フォールバック）
    const yfUrl = `https://query1.finance.yahoo.com/v8/finance/chart/${encodeURIComponent(symbol)}` + `?interval=1d&range=${range}&events=history`;
    const enc = encodeURIComponent(yfUrl);
    return [
        {
            name: 'iseeit.jp proxy',
            url: selfProxy,
            parse: (r)=>r.json()
        },
        {
            name: 'corsproxy.io',
            url: `https://corsproxy.io/?${enc}`,
            parse: (r)=>r.json()
        },
        {
            name: 'allorigins.win',
            url: `https://allorigins.win/get?disableCache=true&url=${enc}`,
            parse: async (r)=>{
                const d = await r.json();
                return JSON.parse(d.contents);
            }
        }
    ];
}
async function $9024cd3e80ddf5bc$var$fetchYahoo() {
    const symbol = document.getElementById('yfSymbol').value.trim() || 'AAPL';
    const range = document.getElementById('yfRange').value;
    $9024cd3e80ddf5bc$var$log(`<span class="info">[FETCH]</span> ${symbol} (${range}) \u{3092}\u{53D6}\u{5F97}\u{4E2D}...`);
    const proxies = $9024cd3e80ddf5bc$var$buildProxies(symbol, range);
    for (const url of proxies)try {
        const res = await fetch(url.url);
        if (!res.ok) continue;
        const j = await res.json();
        const result = j.chart && j.chart.result && j.chart.result[0];
        if (!result) continue;
        const closes = result.indicators.quote[0].close.filter((v)=>v != null);
        if (closes.length < 50) continue;
        $9024cd3e80ddf5bc$var$closeData = closes;
        $9024cd3e80ddf5bc$var$log(`<span class="ok">[OK]</span> ${closes.length}\u{65E5}\u{5206}\u{306E}\u{30C7}\u{30FC}\u{30BF}\u{3092}\u{53D6}\u{5F97}`);
        $9024cd3e80ddf5bc$var$drawMainChart();
        $9024cd3e80ddf5bc$var$enableRun();
        return;
    } catch (e) {}
    $9024cd3e80ddf5bc$var$log(`<span class="err">[ERROR]</span> \u{53D6}\u{5F97}\u{5931}\u{6557}\u{3002}CSV\u{304B}\u{5408}\u{6210}\u{30C7}\u{30FC}\u{30BF}\u{3092}\u{304A}\u{8A66}\u{3057}\u{304F}\u{3060}\u{3055}\u{3044}`);
}
// ── CSV読込 ──────────────────────────────────────────
function $9024cd3e80ddf5bc$var$parseCsv(text) {
    const lines = text.trim().split(/\r?\n/);
    const closes = [];
    // 1行目がヘッダー（数値を含まない）なら飛ばす
    const firstCols = lines[0].split(',').map((c)=>c.replace(/^["']|["']$/g, '').trim());
    const startIdx = firstCols.some((c)=>!isNaN(parseFloat(c)) && c !== '') ? 0 : 1;
    for(let i = startIdx; i < lines.length; i++){
        if (!lines[i].trim()) continue;
        const cols = lines[i].split(',').map((c)=>c.replace(/^["']|["']$/g, '').trim());
        // 最終列を終値とみなす（クォート除去済み）
        const v = parseFloat(cols[cols.length - 1]);
        if (!isNaN(v)) closes.push(v);
    }
    return closes;
}
function $9024cd3e80ddf5bc$var$onCsvFile(input) {
    const f = input.files[0];
    if (!f) return;
    const reader = new FileReader();
    reader.onload = ()=>{
        const closes = $9024cd3e80ddf5bc$var$parseCsv(reader.result);
        if (closes.length < 50) {
            $9024cd3e80ddf5bc$var$log('<span class="err">[ERROR]</span> 50\u4EF6\u4EE5\u4E0A\u306E\u30C7\u30FC\u30BF\u304C\u5FC5\u8981\u3067\u3059');
            return;
        }
        $9024cd3e80ddf5bc$var$closeData = closes;
        $9024cd3e80ddf5bc$var$log(`<span class="ok">[OK]</span> CSV ${closes.length}\u{4EF6}\u{3092}\u{8AAD}\u{8FBC}`);
        $9024cd3e80ddf5bc$var$drawMainChart();
        $9024cd3e80ddf5bc$var$enableRun();
    };
    reader.readAsText(f);
}
// ── 合成データ（デモ用） ──────────────────────────────
function $9024cd3e80ddf5bc$var$generateSynthetic() {
    const n = 300;
    const trend = parseFloat(document.getElementById('synTrend').value); // 年率ドリフト
    const vol = parseFloat(document.getElementById('synVol').value); // 年率ボラ
    let s = (Date.now() & 0xffffffff) >>> 0;
    const rnd = ()=>{
        s = Math.imul(s, 1664525) + 1013904223 >>> 0;
        return s / 4294967296;
    };
    const g = ()=>{
        let u = rnd(), v = rnd();
        if (u < 1e-7) u = 1e-7;
        return Math.sqrt(-2 * Math.log(u)) * Math.cos(2 * Math.PI * v);
    };
    const prices = [
        100
    ];
    const drift = (trend - vol * vol / 2) / 252, dvol = vol / Math.sqrt(252);
    for(let i = 0; i < n; i++)prices.push(prices[prices.length - 1] * Math.exp(drift + dvol * g()));
    $9024cd3e80ddf5bc$var$closeData = prices;
    $9024cd3e80ddf5bc$var$log(`<span class="ok">[OK]</span> \u{5408}\u{6210}\u{30C7}\u{30FC}\u{30BF} ${prices.length}\u{65E5}\u{5206}\u{3092}\u{751F}\u{6210}\u{FF08}\u{30C8}\u{30EC}\u{30F3}\u{30C9}${(trend * 100).toFixed(0)}% \u{30DC}\u{30E9}${(vol * 100).toFixed(0)}%\u{FF09}`);
    $9024cd3e80ddf5bc$var$drawMainChart();
    $9024cd3e80ddf5bc$var$enableRun();
}
function $9024cd3e80ddf5bc$var$enableRun() {
    const b = document.getElementById('runBtn');
    if (b) b.disabled = false;
}
// LSTM学習中などにUIをまとめてロック/アンロック
function $9024cd3e80ddf5bc$var$setBusy(busy) {
    const ids = [
        'dsTabSyn',
        'dsTabCsv',
        'dsTabYf',
        'synTrend',
        'synVol',
        'synBtn',
        'csvFile',
        'yfSymbol',
        'yfRange',
        'yfBtn',
        'lstmWin',
        'runBtn',
        'mcRunBtn'
    ];
    ids.forEach((id)=>{
        const el = document.getElementById(id);
        if (el) el.disabled = busy;
    });
}
// ── 正規化・系列作成 ──────────────────────────────────
function $9024cd3e80ddf5bc$var$normalize(arr) {
    const mn = Math.min(...arr), mx = Math.max(...arr), rng = mx - mn || 1;
    return {
        norm: arr.map((v)=>(v - mn) / rng),
        min: mn,
        max: mx,
        range: rng
    };
}
function $9024cd3e80ddf5bc$var$denorm(v, min, range) {
    return v * range + min;
}
function $9024cd3e80ddf5bc$var$makeSequences(normed, win) {
    const X = [], Y = [];
    for(let i = win; i < normed.length; i++){
        X.push(normed.slice(i - win, i).map((v)=>[
                v
            ]));
        Y.push(normed[i]);
    }
    return {
        X: X,
        Y: Y
    };
}
// ── μ・σ 橋渡し（案B：μ=LSTM予測トレンド、σ=ヒストリカルボラ） ──
function $9024cd3e80ddf5bc$var$historicalVol(prices) {
    const rets = [];
    for(let i = 1; i < prices.length; i++)rets.push(Math.log(prices[i] / prices[i - 1]));
    const mean = rets.reduce((a, b)=>a + b, 0) / rets.length;
    const varr = rets.reduce((a, b)=>a + (b - mean) ** 2, 0) / Math.max(1, rets.length - 1);
    return Math.sqrt(varr) * Math.sqrt(252); // 年率
}
function $9024cd3e80ddf5bc$var$muFromPrediction(futPred, lastActual) {
    // 予測期間全体の累積対数リターンを年率化（日次平均×252は過剰増幅のため避ける）
    const horizon = futPred.length;
    if (horizon < 1) return {
        mu: 0,
        raw: 0,
        clipped: false
    };
    const totalLogRet = Math.log(futPred[futPred.length - 1] / lastActual);
    const raw = totalLogRet * (252 / horizon);
    // 再帰予測のドリフト暴走を防ぐ安全弁（±40%/年でクリップ）
    const CAP = 0.4;
    const mu = Math.max(-CAP, Math.min(CAP, raw));
    return {
        mu: mu,
        raw: raw,
        clipped: Math.abs(raw) > CAP
    };
}
// ── 段階1：LSTM学習・予測（TF.js, CPU） ──────────────
async function $9024cd3e80ddf5bc$var$runLstm() {
    if ($9024cd3e80ddf5bc$var$closeData.length < 50) {
        $9024cd3e80ddf5bc$var$log('<span class="err">[ERROR]</span> \u30C7\u30FC\u30BF\u3092\u5148\u306B\u8AAD\u307F\u8FBC\u3093\u3067\u304F\u3060\u3055\u3044');
        return;
    }
    const win = parseInt(document.getElementById('lstmWin').value);
    const predDays = parseInt(document.getElementById('mcDays').value); // MC期間と合わせLSTMトレンド推定日数
    const epochs = 25, batchSize = 16, trainRatio = 0.8;
    $9024cd3e80ddf5bc$var$log(`<span class="info">[LSTM]</span> \u{5B66}\u{7FD2}\u{958B}\u{59CB} win=${win} epochs=${epochs}\u{FF08}CPU\u{FF09}`);
    $9024cd3e80ddf5bc$var$setBusy(true);
    try {
        const { norm: norm, min: pMin, range: pRange } = $9024cd3e80ddf5bc$var$normalize($9024cd3e80ddf5bc$var$closeData);
        const { X: X, Y: Y } = $9024cd3e80ddf5bc$var$makeSequences(norm, win);
        const trainSize = Math.floor(X.length * trainRatio);
        const xTrain = tf.tensor3d(X.slice(0, trainSize));
        const yTrain = tf.tensor2d(Y.slice(0, trainSize), [
            trainSize,
            1
        ]);
        const xTest = tf.tensor3d(X.slice(trainSize));
        const model = tf.sequential();
        model.add(tf.layers.lstm({
            units: 48,
            returnSequences: true,
            inputShape: [
                win,
                1
            ]
        }));
        model.add(tf.layers.dropout({
            rate: 0.2
        }));
        model.add(tf.layers.lstm({
            units: 24,
            returnSequences: false
        }));
        model.add(tf.layers.dropout({
            rate: 0.2
        }));
        model.add(tf.layers.dense({
            units: 1
        }));
        model.compile({
            optimizer: tf.train.adam(0.001),
            loss: 'meanSquaredError'
        });
        const t0 = performance.now();
        await model.fit(xTrain, yTrain, {
            epochs: epochs,
            batchSize: batchSize,
            verbose: 0,
            callbacks: {
                onEpochEnd: (ep, logs)=>{
                    if ((ep + 1) % 5 === 0) $9024cd3e80ddf5bc$var$log(`  epoch ${ep + 1}/${epochs}  loss=${logs.loss.toFixed(5)}`, 'dim');
                }
            }
        });
        const lstmTime = performance.now() - t0;
        // テスト誤差（RMSE）
        const yPredNorm = Array.from(model.predict(xTest).dataSync());
        const yTestActual = Y.slice(trainSize).map((v)=>$9024cd3e80ddf5bc$var$denorm(v, pMin, pRange));
        const yPredActual = yPredNorm.map((v)=>$9024cd3e80ddf5bc$var$denorm(v, pMin, pRange));
        const rmse = Math.sqrt(yPredActual.reduce((s, v, i)=>s + (v - yTestActual[i]) ** 2, 0) / Math.max(1, yPredActual.length));
        // 多ステップ予測（予測トレンド推定用）
        let seq = norm.slice(norm.length - win).map((v)=>[
                v
            ]);
        const futPred = [];
        for(let s = 0; s < predDays; s++){
            const t = tf.tensor3d([
                seq
            ]);
            const pv = model.predict(t).dataSync()[0];
            futPred.push($9024cd3e80ddf5bc$var$denorm(pv, pMin, pRange));
            seq = [
                ...seq.slice(1),
                [
                    pv
                ]
            ];
            t.dispose();
        }
        xTrain.dispose();
        yTrain.dispose();
        xTest.dispose();
        model.dispose();
        const lastActual = $9024cd3e80ddf5bc$var$closeData[$9024cd3e80ddf5bc$var$closeData.length - 1];
        const muResult = $9024cd3e80ddf5bc$var$muFromPrediction(futPred, lastActual);
        const mu = muResult.mu;
        const sigma = $9024cd3e80ddf5bc$var$historicalVol($9024cd3e80ddf5bc$var$closeData);
        $9024cd3e80ddf5bc$var$lstmOutput = {
            futPred: futPred,
            lastActual: lastActual,
            mu: mu,
            sigma: sigma,
            rmse: rmse,
            lstmTime: lstmTime
        };
        $9024cd3e80ddf5bc$var$log(`<span class="ok">[LSTM\u{5B8C}\u{4E86}]</span> ${lstmTime.toFixed(0)}ms / RMSE=${rmse.toFixed(3)}`);
        $9024cd3e80ddf5bc$var$log(`  \u{2192} \u{4E88}\u{6E2C}\u{30C8}\u{30EC}\u{30F3}\u{30C9} \u{3BC}=${(mu * 100).toFixed(1)}%/\u{5E74}, \u{30D2}\u{30B9}\u{30C8}\u{30EA}\u{30AB}\u{30EB} \u{3C3}=${(sigma * 100).toFixed(1)}%/\u{5E74}`, 'info');
        if (muResult.clipped) $9024cd3e80ddf5bc$var$log(`  \u{203B} \u{4E88}\u{6E2C}\u{30C8}\u{30EC}\u{30F3}\u{30C9}\u{304C}\u{6975}\u{7AEF}\u{306A}\u{305F}\u{3081} \xb140%/\u{5E74} \u{3067}\u{5236}\u{9650}\u{3057}\u{307E}\u{3057}\u{305F}\u{FF08}\u{5143}\u{306E}\u{5024}: ${(muResult.raw * 100).toFixed(1)}%/\u{5E74}\u{FF09}\u{3002}\u{518D}\u{5E30}\u{4E88}\u{6E2C}\u{306F}\u{4E0B}\u{843D}\u{65B9}\u{5411}\u{306B}\u{30C9}\u{30EA}\u{30D5}\u{30C8}\u{3057}\u{3084}\u{3059}\u{304F}\u{3001}\u{5B9F}\u{30C7}\u{30FC}\u{30BF}\u{3067}\u{306F}\u{4E0B}\u{3052}\u{4E88}\u{6E2C}\u{306B}\u{504F}\u{308A}\u{304C}\u{3061}\u{3067}\u{3059}`, 'dim');
        document.getElementById('muVal').textContent = (mu * 100).toFixed(1) + '%';
        document.getElementById('sigmaVal').textContent = (sigma * 100).toFixed(1) + '%';
        document.getElementById('paramCard').style.display = 'block';
        $9024cd3e80ddf5bc$var$drawMainChart(futPred);
    } catch (e) {
        $9024cd3e80ddf5bc$var$log(`<span class="err">[ERROR]</span> LSTM\u{5B9F}\u{884C}\u{4E2D}\u{306B}\u{30A8}\u{30E9}\u{30FC}: ${e.message}`);
    } finally{
        $9024cd3e80ddf5bc$var$setBusy(false);
        // MC実行ボタンは、LSTM予測が成立したときのみ有効
        document.getElementById('mcRunBtn').disabled = $9024cd3e80ddf5bc$var$lstmOutput === null;
    }
}
// ── 段階2：モンテカルロ（GPU）→ 確率の帯 ─────────────
async function $9024cd3e80ddf5bc$var$runMC() {
    if (!$9024cd3e80ddf5bc$var$lstmOutput) {
        $9024cd3e80ddf5bc$var$log('<span class="err">[ERROR]</span> \u5148\u306BLSTM\u4E88\u6E2C\u3092\u5B9F\u884C\u3057\u3066\u304F\u3060\u3055\u3044');
        return;
    }
    const days = parseInt(document.getElementById('mcDays').value);
    const N = parseInt(document.getElementById('mcN').value);
    const be = $9024cd3e80ddf5bc$var$gc.capabilities.webgpu ? 'webgpu' : 'cpu';
    const mcBtn = document.getElementById('mcRunBtn');
    mcBtn.disabled = true;
    $9024cd3e80ddf5bc$var$log(`<span class="info">[MC]</span> ${N.toLocaleString()}\u{672C}\u{306E}\u{7D4C}\u{8DEF}\u{3092}\u{751F}\u{6210}\u{FF08}${be}\u{FF09}`);
    try {
        const r = await $9024cd3e80ddf5bc$var$gc.simulatePaths({
            S0: $9024cd3e80ddf5bc$var$lstmOutput.lastActual,
            mu: $9024cd3e80ddf5bc$var$lstmOutput.mu,
            sigma: $9024cd3e80ddf5bc$var$lstmOutput.sigma,
            steps: days,
            dt: 1 / 252,
            N: N,
            backend: be
        });
        $9024cd3e80ddf5bc$var$mcOutput = r;
        $9024cd3e80ddf5bc$var$log(`<span class="ok">[MC\u{5B8C}\u{4E86}]</span> ${r.elapsed.toFixed(0)}ms / ${r.backend}`);
        const final = r.steps[r.steps.length - 1];
        $9024cd3e80ddf5bc$var$log(`  \u{2192} ${days}\u{65E5}\u{5F8C}\u{FF1A}\u{4E2D}\u{592E}\u{5024} ${final.vals[2].toFixed(1)}, 90%\u{533A}\u{9593} ${final.vals[0].toFixed(1)}\u{301C}${final.vals[4].toFixed(1)}`, 'info');
        // ハイブリッドの実行時間比較
        $9024cd3e80ddf5bc$var$log(`<span class="dim">[\u{6642}\u{9593}\u{6BD4}\u{8F03}] LSTM(CPU) ${$9024cd3e80ddf5bc$var$lstmOutput.lstmTime.toFixed(0)}ms \u{FF0F} MC(${r.backend}) ${r.elapsed.toFixed(0)}ms</span>`);
        $9024cd3e80ddf5bc$var$drawFanChart(r);
    } catch (e) {
        $9024cd3e80ddf5bc$var$log(`<span class="err">[ERROR]</span> \u{30E2}\u{30F3}\u{30C6}\u{30AB}\u{30EB}\u{30ED}\u{5B9F}\u{884C}\u{4E2D}\u{306B}\u{30A8}\u{30E9}\u{30FC}: ${e.message}`);
    } finally{
        mcBtn.disabled = false;
    }
}
// ── メインチャート（実測＋LSTM点予測） ────────────────
function $9024cd3e80ddf5bc$var$drawMainChart(futPred) {
    const ctx = document.getElementById('mainChart');
    const labels = $9024cd3e80ddf5bc$var$closeData.map((_, i)=>i);
    const datasets = [
        {
            label: "\u5B9F\u6E2C\u682A\u4FA1",
            data: $9024cd3e80ddf5bc$var$closeData,
            borderColor: '#22e0ff',
            backgroundColor: 'rgba(34,224,255,.07)',
            borderWidth: 2.5,
            pointRadius: 0,
            fill: true,
            tension: .1
        }
    ];
    if (futPred && futPred.length) {
        const pad = new Array($9024cd3e80ddf5bc$var$closeData.length - 1).fill(null);
        datasets.push({
            label: "LSTM\u4E88\u6E2C",
            data: [
                ...pad,
                $9024cd3e80ddf5bc$var$closeData[$9024cd3e80ddf5bc$var$closeData.length - 1],
                ...futPred
            ],
            borderColor: '#ffd93d',
            backgroundColor: 'transparent',
            borderWidth: 2.5,
            borderDash: [
                6,
                3
            ],
            pointRadius: 0,
            tension: .1
        });
    }
    if ($9024cd3e80ddf5bc$var$chartMain) $9024cd3e80ddf5bc$var$chartMain.destroy();
    $9024cd3e80ddf5bc$var$chartMain = new Chart(ctx, {
        type: 'line',
        data: {
            labels: futPred ? labels.concat(futPred.map((_, i)=>labels.length + i)) : labels,
            datasets: datasets
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    labels: {
                        color: '#9fb0c8',
                        font: {
                            size: 11
                        }
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: '#5a6a82',
                        maxTicksLimit: 8,
                        font: {
                            size: 10
                        }
                    },
                    grid: {
                        color: '#222838'
                    },
                    title: {
                        display: true,
                        text: "\u65E5\u6570",
                        color: '#7a8a9e'
                    }
                },
                y: {
                    ticks: {
                        color: '#5a6a82',
                        font: {
                            size: 10
                        }
                    },
                    grid: {
                        color: '#222838'
                    },
                    title: {
                        display: true,
                        text: "\u4FA1\u683C",
                        color: '#7a8a9e'
                    }
                }
            }
        }
    });
    requestAnimationFrame(()=>requestAnimationFrame(()=>{
            if ($9024cd3e80ddf5bc$var$chartMain) $9024cd3e80ddf5bc$var$chartMain.resize();
        }));
}
// ── ファンチャート（MC確率の帯） ──────────────────────
function $9024cd3e80ddf5bc$var$drawFanChart(r) {
    document.getElementById('fanCard').style.display = 'block';
    const labels = r.steps.map((s)=>s.t);
    if ($9024cd3e80ddf5bc$var$chartFan) $9024cd3e80ddf5bc$var$chartFan.destroy();
    $9024cd3e80ddf5bc$var$chartFan = new Chart(document.getElementById('fanChart'), {
        type: 'line',
        data: {
            labels: labels,
            datasets: [
                {
                    label: '5%',
                    data: r.steps.map((s)=>s.vals[0]),
                    borderColor: 'rgba(255,107,53,.4)',
                    backgroundColor: 'transparent',
                    pointRadius: 0,
                    borderWidth: 1,
                    tension: .1
                },
                {
                    label: 'b1',
                    data: r.steps.map((s)=>s.vals[1]),
                    borderColor: 'transparent',
                    backgroundColor: 'rgba(0,212,255,.10)',
                    fill: '-1',
                    pointRadius: 0,
                    tension: .1
                },
                {
                    label: 'b2',
                    data: r.steps.map((s)=>s.vals[2]),
                    borderColor: 'transparent',
                    backgroundColor: 'rgba(0,212,255,.18)',
                    fill: '-1',
                    pointRadius: 0,
                    tension: .1
                },
                {
                    label: "\u4E2D\u592E\u5024",
                    data: r.steps.map((s)=>s.vals[2]),
                    borderColor: '#22e0ff',
                    backgroundColor: 'transparent',
                    pointRadius: 0,
                    borderWidth: 2.5,
                    tension: .1
                },
                {
                    label: 'b3',
                    data: r.steps.map((s)=>s.vals[3]),
                    borderColor: 'transparent',
                    backgroundColor: 'rgba(0,212,255,.18)',
                    fill: '-1',
                    pointRadius: 0,
                    tension: .1
                },
                {
                    label: 'b4',
                    data: r.steps.map((s)=>s.vals[4]),
                    borderColor: 'transparent',
                    backgroundColor: 'rgba(0,212,255,.10)',
                    fill: '-1',
                    pointRadius: 0,
                    tension: .1
                },
                {
                    label: '95%',
                    data: r.steps.map((s)=>s.vals[4]),
                    borderColor: 'rgba(57,255,20,.5)',
                    backgroundColor: 'transparent',
                    pointRadius: 0,
                    borderWidth: 1.5,
                    tension: .1
                }
            ]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    labels: {
                        color: '#9fb0c8',
                        font: {
                            size: 10
                        },
                        filter: (it)=>[
                                '5%',
                                "\u4E2D\u592E\u5024",
                                '95%'
                            ].includes(it.text)
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: '#5a6a82',
                        maxTicksLimit: 8,
                        font: {
                            size: 10
                        }
                    },
                    grid: {
                        color: '#222838'
                    },
                    title: {
                        display: true,
                        text: "\u65E5\u6570\uFF08\u5C06\u6765\uFF09",
                        color: '#7a8a9e'
                    }
                },
                y: {
                    ticks: {
                        color: '#5a6a82',
                        font: {
                            size: 10
                        }
                    },
                    grid: {
                        color: '#222838'
                    },
                    title: {
                        display: true,
                        text: "\u4FA1\u683C",
                        color: '#7a8a9e'
                    }
                }
            }
        }
    });
    const final = r.steps[r.steps.length - 1];
    document.getElementById('fanInfo').innerHTML = `LSTM\u{306E}\u{70B9}\u{4E88}\u{6E2C}\u{FF08}\u{9EC4}\u{FF09}\u{304C}\u{300C}\u{6700}\u{3082}\u{3042}\u{308A}\u{305D}\u{3046}\u{306A}1\u{672C}\u{300D}\u{3001}MC\u{306E}\u{5E2F}\u{304C}\u{300C}\u{8D77}\u{3053}\u{308A}\u{3046}\u{308B}\u{7BC4}\u{56F2}\u{300D}\u{3002}<br>${r.steps[r.steps.length - 1].t}\u{65E5}\u{5F8C}\u{306F}\u{3001}90%\u{306E}\u{78BA}\u{7387}\u{3067} <strong style="color:#00d4ff">${final.vals[0].toFixed(0)}\u{301C}${final.vals[4].toFixed(0)}</strong> \u{306B}\u{53CE}\u{307E}\u{308B}\u{898B}\u{8FBC}\u{307F}\u{3067}\u{3059}\u{3002}`;
    requestAnimationFrame(()=>requestAnimationFrame(()=>{
            if ($9024cd3e80ddf5bc$var$chartFan) $9024cd3e80ddf5bc$var$chartFan.resize();
        }));
}
document.getElementById("dsTabYf").addEventListener("click", ()=>{
    $9024cd3e80ddf5bc$var$switchDs('yf');
});
document.getElementById("dsTabCsv").addEventListener("click", ()=>{
    $9024cd3e80ddf5bc$var$switchDs('csv');
});
document.getElementById("dsTabSyn").addEventListener("click", ()=>{
    $9024cd3e80ddf5bc$var$switchDs('syn');
});
document.getElementById("yfBtn").addEventListener("click", $9024cd3e80ddf5bc$var$fetchYahoo);
document.getElementById("csvFile").addEventListener("change", (event)=>{
    $9024cd3e80ddf5bc$var$onCsvFile(event.target);
});
document.getElementById("synBtn").addEventListener("click", $9024cd3e80ddf5bc$var$generateSynthetic);
document.getElementById("runBtn").addEventListener("click", $9024cd3e80ddf5bc$var$runLstm);
document.getElementById("mcRunBtn").addEventListener("click", $9024cd3e80ddf5bc$var$runMC);

})();
//# sourceMappingURL=hybrid-forecast.js.map
